function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { useTheme } from '@veneer/theme';
import squared from 'polished/lib/shorthands/size';
import highContrastMediaQuery from '../utils/high_contrast_media_query';
function normalizeQuietArea(value) {
  if (!value || value < 0) return undefined;
  if (value > 100) return 100;
  return value;
}
var useStyles = _ref => {
  var {
    color,
    disabled,
    flippable,
    isRTL,
    isSvg,
    quietArea,
    size
  } = _ref;
  var theme = useTheme();
  return React.useMemo(() => {
    var quietAreaSize = quietArea ? typeof quietArea === 'function' ? quietArea(size) : Math.ceil(quietArea * size / 100) : undefined;
    return _extends({
      boxSizing: 'border-box',
      cursor: disabled ? 'default' : undefined,
      display: 'inline-block',
      filter: disabled ? 'grayscale(1)' : undefined,
      padding: normalizeQuietArea(quietAreaSize),
      userSelect: 'none',
      width: !isSvg ? size : undefined
    }, highContrastMediaQuery(theme), isSvg && _extends({
      color: color ? theme.color[color] || theme.palette.foreground.default : theme.palette.foreground.default,
      fill: 'currentColor'
    }, squared(size)), isRTL && flippable && {
      transform: 'scaleX(-1)'
    });
  }, [color, disabled, flippable, isRTL, isSvg, quietArea, size, theme]);
};
export default useStyles;